module.exports = __webpack_public_path__ + "static/media/fight-sword.22847ab2.webp";